import styled from 'styled-components';

export const StyledFocusedActionText = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;

  > span {
    margin-top: 2px;
  }
`;
